// A 404 Error page when the user visits an undefined URL
import React from 'react';
import '../Styles/NotFound.css';

const NotFound = () => {
    return ( 
        <div className="not_found_error">
            <h1 className="error_number">404</h1>
            <p className="error_type">Page Not Found</p>
            <p className="error_description">The requested URL was not found on this server.</p>
            <a href="/">
                <button className="home_button">Back to Home</button>
            </a>
        </div>
    );
}
 
export default NotFound;
